
import AppData from "../../../Model/AppData";

export default class Navigator {
    static getTableQr() {
        let href = window.location.href
        return href.substr(href.lastIndexOf('/') + 1) 
    }
    static goToCategory = (type) => {
        let path = '/category/'+ window.table_qr
        if (type == 'url') {
            return path
        }
        AppData.data.props.history.push(path)
    }
    static goToSelectDeliveryLocation = (options) => {
        let newState = options || {
            selectLocationBack: null,
            hideFooter: false,
        }
        if (options && options.back) {
            newState.selectLocationBack = options.back
        }
        AppData.data.props.history.push('/select_location/'+ window.table_qr, newState)
    }
}